export const breakpoints = {
  xs: 350,
  sm: 430,
  md: 1024,
  lg: 1440,
  xl: 1920,
} as const

export const breakpointUpTo = (breakpoint: number) => {
  return `@media screen and (max-width:${breakpoint - 1}px)`
}

export const breakpointFrom = (breakpoint: number) => {
  return `@media screen and (min-width:${breakpoint}px)`
}
